
import React from "react";
import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

interface FactoryData {
  name: string;
  completedOrders: number;
  pendingOrders: number;
  efficiency: number;
}

interface FactoryPerformanceProps {
  factories: FactoryData[];
}

export function FactoryPerformance({ factories }: FactoryPerformanceProps) {
  return (
    <Card className="glass-card animate-slideRight">
      <div className="p-6 border-b border-border">
        <h2 className="text-lg font-semibold">Factory Performance</h2>
      </div>
      <div className="p-6">
        <div className="space-y-8">
          {factories.map((factory) => (
            <div key={factory.name} className="space-y-2">
              <div className="flex items-center justify-between">
                <h3 className="font-medium">{factory.name}</h3>
                <span className="text-sm font-medium">{factory.efficiency}% Efficiency</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <span>{factory.completedOrders} completed</span>
                <span>•</span>
                <span>{factory.pendingOrders} pending</span>
              </div>
              <Progress value={factory.efficiency} className="h-2" />
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
